export default __webpack_public_path__ + "static/media/github_icon.c57108f5.svg";